import { lazy } from 'react'

const DashboardEcommerce = lazy(() => import('../../views/dashboard/ecommerce'))

const DashboardRoutes = [
  {
    path: '/dashboard/ecommerce',
    element: <DashboardEcommerce />,
    meta: {
      action: 'read',
      resource: 'dashboard'
    }
  }
]

export default DashboardRoutes
